export const experienceOptions = [
  {
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/55c44674a5210becc1faa6386858bc3efdcad18535814140a9cf1bb54df2701e?placeholderIfAbsent=true&apiKey=2bad5dddb78c4e879392057a342234a5",
    values: {
      English: "Very dissatisfied",
      Chinese: "非常不满意",
      Spanish: "Muy insatisfecho",
      French: "Très insatisfait",
      Dutch: "Zeer ontevreden",
      German: "Sehr unzufrieden",
      Japanese: "非常に不満",
    },
    ratingValue: 1,
    Question: {
      English: "What is your overall experience with",
      Chinese: "请问您对的整体体验如何？",
      Spanish: "¿Cuál es tu experiencia general con",
      French: "Quelle est votre expérience globale avec?",
      Dutch: "Wat is uw algehele ervaring met",
      German: "Wie ist Ihre Gesamte erfahrung mit ",
      Japanese: "あなたの全体的な経験は何ですか",
    },
    descriptions: {
      English: "Experience with this service has been worse and needs improvement",
      Chinese: "这项服务的体验非常差，需要改进",
      Spanish: "La experiencia con este servicio ha sido peor y necesita mejorar",
      French: "L’expérience avec ce service a été pire et doit être améliorée",
      Dutch: "De ervaring met deze service is slechter en moet worden verbeterd",
      German: "Die Erfahrung mit diesem Service ist schlechter geworden und muss verbessert werden",
      Japanese: "このサービスの経験は悪化しており、改善が必要です",
 
    },
    comments: {
      English: "Not good at all? Can you share what's the fail?",
      Chinese: "一点都不好？可以分享下不好在什么地方吗？",
      Spanish: "¿Nada bueno? ¿Puedes compartir qué falló?",
      French: "Pas bon du tout ? Pouvez-vous partager ce qui a échoué?",
      Dutch: "Helemaal niet goed? Kun je vertellen wat er aan de hand is?",
      German: "Gar nicht gut? Können Sie uns mitteilen, was schiefgelaufen ist?",
      Japanese: "全然良くないですか？何が失敗したか教えてください。",
    },
    optionalText: {
      English: "(optional)",
      Chinese: "(可选)",
      Spanish: "(opcional)",
      French: "(facultatif)",
      Dutch: "(optioneel)",
      German: "(optional)",
      Japanese: "(任意)"
    },
    placeholderText: {
      English: "Leave your comments here",
      Chinese: "在这里留下你的评论",
      Spanish: "Deja tus comentarios aqui",
      French: "Laissez vos commentaires ici",
      Dutch: "Laat hier uw opmerkingen achter",
      German: "Lassen Sie Ihre Kommentare hier",
      Japanese: "ここにコメントを残してください",
    }
  },
  {
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/903750a8586204b56d1235047079b052a7151b0f84cbb0c4cef0a6af1600c72f?placeholderIfAbsent=true&apiKey=2bad5dddb78c4e879392057a342234a5",
    values: {
      English: "Dissatisfied",
      Chinese: "不满意",
      Spanish: "Descontento",
      French: "Insatisfaite",
      Dutch: "ontevreden",
      German: "Unzufrieden",
      Japanese: "不満",
    },
    ratingValue: 2,
    Question: {
      English: "What is your overall experience with",
      Chinese: "请问您对的整体体验如何？",
      Spanish: "¿Cuál es tu experiencia general con",
      French: "Quelle est votre expérience globale avec?",
      Dutch: "Wat is uw algehele ervaring met",
      German: "Wie ist Ihre Gesamte erfahrung mit ",
      Japanese: "あなたの全体的な経験は何ですか",
    },
    descriptions: {
      English: "Experience with this service has been bad and needs improvement",
      Chinese: "这项服务的体验很糟糕，需要改进",
      Spanish: "La experiencia con este servicio ha sido mala y necesita mejorar ",
      French: "L’expérience avec ce service a été mauvaise et doit être améliorée",
      Dutch: "Ervaring met deze service is slecht en moet worden verbeterd",
      German: "Die Erfahrung mit diesem Service ist schlecht und muss verbessert werden",
      Japanese: "このサービスの経験は悪く、改善が必要です",
 
    },
    comments: {
      English: "Oh dear! Can you share details of what’s going wrong?",
      Chinese: "您可以分享下不好在什么地方吗？",
      Spanish: "¡Oh, vaya! ¿Puedes compartir detalles de lo que está fallando? ",
      French: "Oh, mon Dieu! Pouvez-vous nous donner des détails sur ce qui ne va pas?",
      Dutch: "Oh jee! Kunt u details delen over wat er misgaat?",
      German: "Oh je! Können Sie uns sagen, was schief läuft?",
      Japanese: "ああ！何が問題なのか、詳細を教えていただけますか?(オプション)",
    },
    optionalText: {
      English: "(optional)",
      Chinese: "(可选)",
      Spanish: "(opcional)",
      French: "(facultatif)",
      Dutch: "(optioneel)",
      German: "(optional)",
      Japanese: "(任意)"
    },
    placeholderText: {
      English: "Leave your comments here",
      Chinese: "在这里留下你的评论",
      Spanish: "Deja tus comentarios aqui",
      French: "Laissez vos commentaires ici",
      Dutch: "Laat hier uw opmerkingen achter",
      German: "Lassen Sie Ihre Kommentare hier",
      Japanese: "ここにコメントを残してください",
    }
  },
  {
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/b75f691d580836d8ea95260c640fb3a2a2090b835496ef20e8fabe38e3c9fbea?placeholderIfAbsent=true&apiKey=2bad5dddb78c4e879392057a342234a5",
    values: {
      English: "Not so satisfied",
      Chinese: "不太满意",
      Spanish: "No tan satisfecho",
      French: "Pas si satisfait",
      Dutch: "Niet zo tevreden",
      German: "Nicht so zufrieden",
      Japanese: "あまり満足していない",
    },
    ratingValue: 3,
    Question: {
      English: "What is your overall experience with",
      Chinese: "请问您对的整体体验如何？",
      Spanish: "¿Cuál es tu experiencia general con",
      French: "Quelle est votre expérience globale avec?",
      Dutch: "Wat is uw algehele ervaring met",
      German: "Wie ist Ihre Gesamte erfahrung mit ",
      Japanese: "あなたの全体的な経験は何ですか",
    },
    descriptions: {
      English: "Experience with this service has been just satisfactory",
      Chinese: "这项服务的体验比较一般",
      Spanish: "La experiencia con este servicio ha sido simplemente satisfactoria",
      French: "L’expérience avec ce service a été tout simplement satisfaisante",
      Dutch: "De ervaring met deze service is gewoon bevredigend",
      German: "Die Erfahrungen mit diesem Service sind nur zufriedenstellend",
      Japanese: "このサービスの体験はただの満足でした。",
 
    },
    comments: {
      English: "So so. Can you share why just average?",
      Chinese: "您能分享一下为什么只达到一般水平吗？",
      Spanish: "Más o menos. ¿Puedes compartir por qué solo promedio? ",
      French: " Comme ci comme ça. Pouvez-vous nous dire pourquoi il suffit de faire la moyenne?",
      Dutch: "Zo zo. Kun je vertellen waarom gewoon gemiddeld?",
      German: "Mittelmäßig. Können Sie uns sagen, warum nur durchschnittlich ist?",
      Japanese: "まあまあです。なぜ平均的なのか教えていただけますか?(オプション)",
    },
    optionalText: {
      English: "(optional)",
      Chinese: "(可选)",
      Spanish: "(opcional)",
      French: "(facultatif)",
      Dutch: "(optioneel)",
      German: "(optional)",
      Japanese: "(任意)"
    },
    placeholderText: {
      English: "Leave your comments here",
      Chinese: "在这里留下你的评论",
      Spanish: "Deja tus comentarios aqui",
      French: "Laissez vos commentaires ici",
      Dutch: "Laat hier uw opmerkingen achter",
      German: "Lassen Sie Ihre Kommentare hier",
      Japanese: "ここにコメントを残してください",
    }
  },
  {
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/86a7b385b4bcfce323f82f712792633ec7c0e2177355eb7b13dc1d46b6f25dd4?placeholderIfAbsent=true&apiKey=2bad5dddb78c4e879392057a342234a5",
    values: {
      English: "Satisfied",
      Chinese: "满意",
      Spanish: "Satisfecha ",
      French: "Satisfaite ",
      Dutch: "Tevreden",
      German: "Zufrieden",
      Japanese: "満足",
    },
    ratingValue: 4,
    Question: {
      English: "What is your overall experience with",
      Chinese: "请问您对的整体体验如何？",
      Spanish: "¿Cuál es tu experiencia general con",
      French: "Quelle est votre expérience globale avec?",
      Dutch: "Wat is uw algehele ervaring met",
      German: "Wie ist Ihre Gesamte erfahrung mit ",
      Japanese: "あなたの全体的な経験は何ですか",
    },
    descriptions: {
      English: "Experience with this service has been good and according to expectation",
      Chinese: "这项服务的体验很好，符合预期",
      Spanish: "La experiencia con este servicio ha sido buena y acorde a las expectativas",
      French: "L’expérience avec ce service a été bonne et conforme aux attentes",
      Dutch: "De ervaring met deze service is goed en naar verwachting",
      German: "Die Erfahrungen mit diesem Service waren gut und entsprachen den Erwartungen",
      Japanese: "このサービスの経験は良好で、期待通りです",
 
    },
    comments: {
      English: "Great! Can you share with us more about your experience?",
      Chinese: "太棒了！您能和我们分享更多您的经历吗？",
      Spanish: "¡Bien! ¿Puedes contarnos más sobre tu experiencia? ",
      French: "Génial! Pouvez-vous nous en dire plus sur votre expérience?",
      Dutch: "Geweldig! Kun je meer met ons delen over je ervaring?",
      German: "Großartig! Können Sie uns mehr über Ihre Erfahrungen erzählen?",
      Japanese: "すごい！あなたの経験について詳しく教えてください。(オプション)",
    },
    optionalText: {
      English: "(optional)",
      Chinese: "(可选)",
      Spanish: "(opcional)",
      French: "(facultatif)",
      Dutch: "(optioneel)",
      German: "(optional)",
      Japanese: "(任意)"
    },
    placeholderText: {
      English: "Leave your comments here",
      Chinese: "在这里留下你的评论",
      Spanish: "Deja tus comentarios aqui",
      French: "Laissez vos commentaires ici",
      Dutch: "Laat hier uw opmerkingen achter",
      German: "Lassen Sie Ihre Kommentare hier",
      Japanese: "ここにコメントを残してください",
    }
  },
  {
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/f219ecf23b885cc56e7b4ca429ef09054a90a8ac690485cfeb242d780d4e84da?placeholderIfAbsent=true&apiKey=2bad5dddb78c4e879392057a342234a5",
    values: {
      English: "Very satisfied",
      Chinese: "非常满意",
      Spanish: "Muy satisfecho ",
      French: "Très satisfait  ",
      Dutch: "Zeer tevreden",
      German: "Sehr zufrieden",
      Japanese: "非常に満足しています",
    },
    ratingValue: 5,
    question: {
      English: "What is your overall experience with",
      Chinese: "请问您对的整体体验如何？",
      Spanish: "¿Cuál es tu experiencia general con",
      French: "Quelle est votre expérience globale avec?",
      Dutch: "Wat is uw algehele ervaring met",
      German: "Wie ist Ihre Gesamte erfahrung mit ",
      Japanese: "あなたの全体的な経験は何ですか",
    },
    descriptions: {
      English: "Experience with this service has been great and above expectation",
      Chinese: "这项服务的体验非常好，超出了预期",
      Spanish: "La experiencia con este servicio ha sido excelente y ha superado las expectativas ",
      French: "L’expérience avec ce service a été excellente et au-delà des attentes ",
      Dutch: "De ervaring met deze service was geweldig en boven verwachting",
      German: "Die Erfahrung mit diesem Service war großartig und übertraf die Erwartungen",
      Japanese: "このサービスでの経験は素晴らしく、期待を上回っています",
 
    },
    comments: {
      English: "Awesome! Can you share with us more about your experience?",
      Chinese: "太棒了！您能和我们分享更多您的经历吗？",
      Spanish: "¡Genial! ¿Puedes contarnos más sobre tu experiencia?",
      French: " Génial! Pouvez-vous nous en dire plus sur votre expérience?",
      Dutch: "Ontzagwekkend! Kun je meer met ons delen over je ervaring?",
      German: "Prima! Können Sie uns mehr über Ihre Erfahrungen erzählen?",
      Japanese: "素晴らしい！あなたの経験について詳しく教えてください。(オプション)",
    },
    optionalText: {
      English: "(optional)",
      Chinese: "(可选)",
      Spanish: "(opcional)",
      French: "(facultatif)",
      Dutch: "(optioneel)",
      German: "(optional)",
      Japanese: "(任意)"
    },
    placeholderText: {
      English: "Leave your comments here",
      Chinese: "在这里留下你的评论",
      Spanish: "Deja tus comentarios aqui",
      French: "Laissez vos commentaires ici",
      Dutch: "Laat hier uw opmerkingen achter",
      German: "Lassen Sie Ihre Kommentare hier",
      Japanese: "ここにコメントを残してください",
    }
  },
];